const protectedRoutes = [

];

export default protectedRoutes;
